<template>
  <div>
    <span
      v-for="key in Object.keys(availableStatuses[statusKey])"
      :key="`case-status-badge-${key}`"
      class="badge rounded-pill me-1 mb-1 text-uppercase"
      :class="statusClass(key)"
    >
      {{ key.split("_").join(" ") }}
    </span>
  </div>
</template>

<script>
export default {
  props: ["caseStatus", "groupType"],
  computed: {
    statusClass() {
      return (key) => {
        if (key == "payment") {
          if (this.caseStatus?.claim && this.caseStatus?.memo) {
            return "bg-success";
          } else if (!this.caseStatus?.claim && !this.caseStatus?.memo) {
            return "bg-white text-muted semi-transparent";
          } else {
            return "bg-warning text-dark";
          }
        } else if (["site_visit", "site_diary"].includes(key)) {
          if (
            this.caseStatus &&
            this.caseStatus[key] &&
            this.caseStatus[key] === true
          ) {
            return "bg-success";
          } else if (
            this.caseStatus &&
            this.caseStatus[key] &&
            this.caseStatus[key] === "pending"
          ) {
            return "bg-warning text-dark";
          } else if (
            this.caseStatus &&
            this.caseStatus[key] &&
            this.caseStatus[key] === "rejected"
          ) {
            return "bg-danger text-dark";
          } else {
            return "bg-white text-muted semi-transparent";
          }
        } else {
          return this.caseStatus && this.caseStatus[key]
            ? "bg-success"
            : "bg-white text-muted semi-transparent";
        }
      };
    },
    availableStatuses() {
      const _statuses = {};

      Object.keys(this.Helper.allCaseStatuses).forEach((key) => {
        _statuses[key] = {};

        this.Helper.allCaseStatuses[key].forEach((e) => {
          _statuses[key][e] = false;
        });
      });

      // INFS-1423: the Work Order step is hidden for every role now, so
      // nothing writes componentStatus.wo any more and this pill could never
      // turn green. Dropped for all roles, not just JKR as before. Restore
      // the role check together with the `hidden` flag in CaseDetails.vue.
      delete _statuses.default.wo;

      return _statuses;
    },
    statusKey() {
      return ["Electrical", "Emergency"].includes(this.groupType)
        ? "others"
        : "default";
    },
  },
};
</script>